import React from 'react'
import { MediaViewer } from './MediaViewer'

// The app's photo / video viewer under its original name and props
// (media, mediaType, imageX, imageY); see MediaViewer for galleries.
export const ImageModal = (props) => <MediaViewer {...props} />
